import { useQuery } from "@tanstack/react-query";
import { getAppState } from "@/api/appState";
import useAppStore from "@/store/useAppStore";
import { useEffect } from "react";

export default function useAppStateQuery() {
  const setAppState = useAppStore((s) => s.setAppState);

  const query = useQuery({
    queryKey: ["app_state"],
    queryFn: getAppState,
    staleTime: 5000,
  });

  useEffect(() => {
    if (query.data) {
      setAppState(query.data);
    }
  }, [query.data, setAppState]);

  return query;
}
